import { useEffect, useState } from 'react';

/** Phones and tablets — below Tailwind `lg`. Extension-based exports target desktop Chrome only. */
const MOBILE_OR_TABLET_MQ = '(max-width: 1023px)';

/**
 * True when the viewport is phone- or tablet-sized (Chrome extension exports unavailable).
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_OR_TABLET_MQ);
    const sync = () => setIsMobile(mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  return isMobile;
}
